import { render, staticRenderFns } from "./BulkCreateAWB.vue?vue&type=template&id=cfe1f7b4&"
import script from "./BulkCreateAWB.vue?vue&type=script&lang=js&"
export * from "./BulkCreateAWB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports